export const CONTACT_GROUPS = 'contact-groups';
export const FILE_PANEL = 'file';
export const FILTERS_PANEL = 'filters';
export const FOLDER_SETTINGS = 'folder-settings';
export const ITEM_KITS = 'item-kits';
export const CALENDAR_FILTERS = 'calendar-filters';
export const NONE = 'none';
